
export default class AccountJD {
    constructor() {
        this.version = "1.0.0.0";
        this.baseUrl = "https://account.jdsoftwarellc.com/";
        //this.baseUrl = "https://localhost:5001/";
        this.gameId = 6;
    }
    Login(username, password) {
        let postData = {
            username: username,
            password: password
        };

        var url = this.baseUrl + "api/Authentication/Login";

        return this.Fetch("POST", url, JSON.stringify(postData), "application/json")
            .then(function (rawData) {
                let data = JSON.parse(rawData);
                return data;
            });
        //todo: register if not user exist
    };
    Register(data, password) {
        let postData = {
            name: data.name,
            email: data.email,
            facebookId: data.facebookId,
            password: password || data.password,
            avatar: data.avatar,
            emailSubscribe: data.emailSubscribe,
        };

        var url = this.baseUrl + "api/Authentication/Register";
        return this.Fetch("POST", url, JSON.stringify(postData), "application/json")
            .then(function (rawData) {
                let data = JSON.parse(rawData);
                return data;
            });
    };
    LoginOrCreate(data) {
        let username = data.email;
        let password = data.password;
        if (!username) username = data.facebookId;
        if (!username) return Promise.reject(new Error('Cannot log in.  No email or facebookId'))
        return this.Login(username, password)
            .catch((e) => {
                return this.Register(data);
            })
    }
    PasswordReset(email) {
        let postData = {
            email: email
        };
        var url = this.baseUrl + "api/Authentication/SendPasswordReset";
        return this.Fetch("POST", url, JSON.stringify(postData), "application/json")
            .then(function (rawData) {
                return rawData;
            });
    };
    UpdateUser(data) {
        let postData = {
            id: data.id,
            name: data.name,
            email: data.email,
            facebookId: data.facebookId,
            avatar: data.avatar,
            emailSubscribe: data.emailSubscribe
        };
        var url = this.baseUrl + "api/User";
        return this.MakeRequest("POST", url, JSON.stringify(postData), "application/json")
            .then(function (rawData) {
                let data = JSON.parse(rawData);
                return data;
            });
    };
    async UploadAvatarUrl(id, imageUrl) {
        return this.UploadAvatar(id, null, imageUrl);
    }
    async UploadAvatar(id, imageFile, imageUrl) {
        //upload avatar 

        var url = this.baseUrl + `api/Avatar/${id}?url=${encodeURIComponent(imageUrl)}`;
        var postData = new FormData();
        // Add the file to the request.
        postData.append("file", imageFile);

        const newImageUrl = await this.Fetch("POST", url, postData, "");
        return newImageUrl;

    };
    GetUser(id) {
        if (!id) return Promise.reject("no user id");

        var url = this.baseUrl + `api/User/${id}`;

        return fetch(url, {
            method: 'GET',
            cache: 'no-cache',
            mode: "no-cors",
        }).then(function (response) {
            let data = response.json();
            return data;
        });
    };
    GetUserData(id, gameId) {

        if (!gameId && gameId != 0) gameId = this.gameId;
        //check input parameters
        if (!id) return Promise.reject("no user id");

        var url = `api/UserData/${id}?gameId=${gameId}`;
        url = this.baseUrl + url;

        return this.Fetch("GET", url).then(function (data) {
            return JSON.parse(data);
        });
    };
    GetUserDataPublic(id, gameId) {

        if (!gameId && gameId != 0) gameId = this.gameId;
        //check input parameters
        if (!id) return Promise.reject("no user id");

        var url = `api/UserData/Public/${id}?gameId=${gameId}`;
        url = this.baseUrl + url;

        return this.Fetch("GET", url).then(function (data) {
            return JSON.parse(data);
        });
    };
    SaveUserData(userId, data, gameId) {
        if (!gameId && gameId != 0) gameId = this.gameId;
        //check input parameters/data
        if (!userId) return Promise.reject(new Error('no user id'));
        if (!data) return Promise.reject(new Error('no user data'));

        var url = `api/UserData/${userId}?gameId=${gameId}`;
        url = this.baseUrl + url;

        return this.MakeRequest("POST", url, JSON.stringify(data));
    };
    MakeRequest(method, url, data, ContentType) {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open(method, url);
            xhr.setRequestHeader("cache-control", "private");
            if (ContentType) xhr.setRequestHeader("Content-type", ContentType);
            xhr.onload = function () {
                if (this.status >= 200 && this.status < 300) {
                    // var returnData = JSON.parse(xhr.responseText);
                    resolve(xhr.responseText);
                } else {
                    reject({
                        status: this.status,
                        statusText: xhr.statusText
                    });
                }
            };
            xhr.onerror = function () {
                reject({
                    status: this.status,
                    statusText: xhr.statusText,
                    message: xhr.responseText
                });
            };
            if (!data)
                xhr.send();
            else
                xhr.send(data);
        });
    };
    async Fetch(method, url, data, contentType) {
        let headers = { 'Content-Type': contentType || 'text/plain' };
        if (contentType === "") headers = {}; //override to clear content type
        const response = await fetch(url, {
            method: method, // *GET, POST, PUT, DELETE, etc.
            headers: headers,
            body: data
        })
        if (!response.ok) {
            //todo: how to get server to return error message such as statusText
            const status = response.status;
            const statusText = response.statusText;
            const message = await response.text();
            const error = new Error(message);
            error.status = status;
            error.statusText = statusText;
            error.message = message;
            throw error;
        }
        const output = await response.text();//response.json()
        return output;
    }
}
